// Groups listing
export const GET_GROUPS_LIST = "GET_GROUPS_LIST";
export const GET_GROUPS_LIST_SUCCESS = "GET_GROUPS_LIST_SUCCESS";
export const GET_GROUPS_LIST_ERROR = "GET_GROUPS_LIST_ERROR";

// Add group
export const ADD_GROUP = "ADD_GROUP";
export const ADD_GROUP_SUCCESS = "ADD_GROUP_SUCCESS";
export const ADD_GROUP_ERROR = "ADD_GROUP_ERROR";

// Edit group
export const EDIT_GROUP = "EDIT_GROUP";
export const EDIT_GROUP_SUCCESS = "EDIT_GROUP_SUCCESS";
export const EDIT_GROUP_ERROR = "EDIT_GROUP_ERROR";

// Delete group
export const DELETE_GROUP = "DELETE_GROUP";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const DELETE_GROUP_ERROR = "DELETE_GROUP_ERROR";

// Set group data
export const SET_GROUPS_LIST = "SET_GROUPS_LIST";

// Set search
export const SET_GROUPS_SEARCH = "SET_GROUPS_SEARCH";

// Set sort field
export const SET_GROUPS_SORT_FIELD = "SET_GROUPS_SORT_FIELD";

// Set sort order
export const SET_GROUPS_SORT_ORDER = "SET_GROUPS_SORT_ORDER";

// Set page
export const SET_GROUPS_PAGE = "SET_GROUPS_PAGE";

// Ban user from group
export const BAN_USER_FROM_GROUP = "BAN_USER_FROM_GROUP";
export const BAN_USER_FROM_GROUP_SUCCESS = "BAN_USER_FROM_GROUP_SUCCESS";
export const BAN_USER_FROM_GROUP_ERROR = "BAN_USER_FROM_GROUP_ERROR";

// Unban user from group
export const UNBAN_USER_FROM_GROUP = "UNBAN_USER_FROM_GROUP";
export const UNBAN_USER_FROM_GROUP_SUCCESS = "UNBAN_USER_FROM_GROUP_SUCCESS";
export const UNBAN_USER_FROM_GROUP_ERROR = "UNBAN_USER_FROM_GROUP_ERROR";

// Pinned groups
export const GET_PINNED_GROUPS = "GET_PINNED_GROUPS";
export const GET_PINNED_GROUPS_SUCCESS = "GET_PINNED_GROUPS_SUCCESS";
export const GET_PINNED_GROUPS_ERROR = "GET_PINNED_GROUPS_ERROR";
export const SET_PINNED_GROUPS = "SET_PINNED_GROUPS";
export const SAVE_PINNED_GROUPS = "SAVE_PINNED_GROUPS";
export const SAVE_PINNED_GROUPS_DONE = "SAVE_PINNED_GROUPS_DONE";
